module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.organizationLists,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'name', $$v)
            },
            expression: "filters['name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Short Name",
      "field": "shortName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['shortName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'shortName', $$v)
            },
            expression: "filters['shortName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact Person",
      "field": "contactPerson",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactPerson']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactPerson', $$v)
            },
            expression: "filters['contactPerson']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "field": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Type",
      "field": "taxType",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['taxType']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'taxType', $$v)
            },
            expression: "filters['taxType']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Merge"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Checkbox', {
          attrs: {
            "binary": true
          },
          on: {
            "change": function($event) {
              return _vm.updateMergeStatus(slotProps.data)
            }
          },
          model: {
            value: (slotProps.data.mergeOrg),
            callback: function($$v) {
              _vm.$set(slotProps.data, "mergeOrg", $$v)
            },
            expression: "slotProps.data.mergeOrg"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editOrganization(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "visible": _vm.addDisplayBasic,
      "header": "Organization Details",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addOrganisation.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12"
  }, [_c('h4', {
    staticStyle: {
      "color": "#3c8dbc",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Organization Info")])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Short Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "shortName"
    },
    model: {
      value: (_vm.shortName),
      callback: function($$v) {
        _vm.shortName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "shortName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactPerson"
    }
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactPerson"
    },
    model: {
      value: (_vm.contactPerson),
      callback: function($$v) {
        _vm.contactPerson = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactPerson"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactNumber"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactNumber"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "organizationType"
    }
  }, [_vm._v("Organization Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.organizationTypes,
      "optionLabel": "name",
      "optionValue": "value",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.taxType),
      callback: function($$v) {
        _vm.taxType = $$v
      },
      expression: "taxType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Pan/Vat No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "panNo"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.panNo),
      callback: function($$v) {
        _vm.panNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "panNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12"
  }, [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('div', {
    staticClass: "flex gap-2 mt-2"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Upload Image",
      "icon": "pi pi-upload"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showItemUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.imageList.length > 0) ? _c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "label": "View Images",
      "icon": "pi pi-images"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewImage.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.editing) ? [_c('div', {
    staticClass: "p-field p-col-12"
  }, [_c('h4', {
    staticStyle: {
      "color": "#3c8dbc",
      "margin": "20px 0"
    }
  }, [_vm._v("User Info")])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "userName"
    }
  }, [_vm._v("Full Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "userName"
    },
    model: {
      value: (_vm.nameOfuser),
      callback: function($$v) {
        _vm.nameOfuser = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "nameOfuser"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "password",
      "disabled": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1)] : _vm._e()], 2)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Upload Images",
      "visible": _vm.showItemUploadDialog,
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showItemUploadDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-outlined",
          attrs: {
            "label": "Back"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeImageUpload.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancelImageUpload.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid"
  }, [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "fileInput",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileSelect
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-button p-component p-button-outlined mb-4",
    attrs: {
      "for": "fileInput"
    }
  }, [_c('i', {
    staticClass: "pi pi-upload mr-2"
  }), _vm._v("Select Images (max 1MB)\n          ")]), _vm._v(" "), _c('Carousel', {
    attrs: {
      "value": _vm.previewImages,
      "numVisible": 3,
      "numScroll": 1,
      "circular": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "border-1 surface-border border-round m-2 text-center py-5 px-3"
        }, [_c('div', {
          staticClass: "mb-3"
        }, [_c('img', {
          staticClass: "w-6 shadow-2",
          staticStyle: {
            "max-height": "200px"
          },
          attrs: {
            "src": slotProps.data.url
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "file-size"
        }, [_vm._v(_vm._s(_vm.formatFileSize(slotProps.data.size)))])]), _vm._v(" "), _c('div', [_c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.removeNewImage(slotProps.index)
            }
          }
        })], 1)])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '40vw'
    }),
    attrs: {
      "visible": _vm.deleteDialogVisible,
      "header": "Are you sure you want to delete?",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.deleteDialogVisible = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteOrganization.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "label": "Back"
          },
          on: {
            "click": function($event) {
              _vm.deleteDialogVisible = false
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid"
  }, [_c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "for": "deleteReason"
    }
  }, [_vm._v("Delete Reason:")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('Textarea', {
    attrs: {
      "id": "deleteReason",
      "rows": "5"
    },
    model: {
      value: (_vm.deleteReason),
      callback: function($$v) {
        _vm.deleteReason = $$v
      },
      expression: "deleteReason"
    }
  })], 1)])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b6abff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/branchCompany.vue
// module id = 2128
// module chunks = 0